import React, { useEffect, useState } from 'react';
import '../../styles/globals.css'
import { Box, Button, Divider, Link, Paper, Typography } from '@mui/material'
import karmaStyles from '../../styles/KarmaPool.module.css'
import DashboardMenuHeaderComponent from './header/DashboardMenuHeaderComponent';
import DashboardLogoutFooterComponent from './footer/DashboardLogoutFooterComponent';
import CycleAllocatedTokens from './cycles/CycleAllocatedTokens';
import CycleTimer from './cycles/CycleTimer';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';

import { Elements, PaymentElement } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import getStripe from './stripe/StripeLoader';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe('pk_test_qblFNYngBkEdjEZ16jxxoWSM');

function DashboardRoot() {

    const options = {
        // passing the client secret obtained from the server
        clientSecret: 'pk_test_51NlHKq2MsJ2UXvaBTZGfefwQTqUkXOqltZju9OBTKbeoE9lFA4EqCXOO90Fd0L9bKBM9jhrfnyTfJ9owEWI4ZADs00XMYzFXiK',
    };

    const karmaContext = useKarmaPoolContext();

    useEffect(() => {
        karmaContext.notificationManager.fetchNotifications();
    }, []);


    const [notifications, setNotifications] = useState("");

    useEffect(() => {
        if (karmaContext.local.notifications === undefined ||
            karmaContext.local.notifications[0] === undefined) {
            return;
        }

        setNotifications(karmaContext.local.notifications);

    }, [karmaContext.local.notifications]);

    if (karmaContext.local.user === undefined || karmaContext.local.user === null) {
        return (
            <Box className={karmaStyles.homepageBox}>
                <DashboardMenuHeaderComponent
                    homeEnabled={true}
                    showMenu={false} />
                <p style={{ color: "whitesmoke" }}>
                    Please wait..</p>
            </Box>
        );
    }

    if (karmaContext.local.user.seenLoginNotification === undefined || !karmaContext.local.user.seenLoginNotification) {
        return RenderNotifications(karmaContext, notifications);
    }

    if (!karmaContext.local.user.member) {
        return (<RenderDashboardNotMember options={options} />)
    }
    else {
        return RenderDashboardPrimary();
    }
}

function RenderNotifications(karmaContext, notifications) {
    return (
        <Box className={karmaStyles.homepageBox}>
            <DashboardMenuHeaderComponent
                homeEnabled={true}
                showMenu={false} />
            <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "1.5rem", marginBottom: "1rem" }}>
                    <Box sx={{
                        width: "77.5%", maxWidth: "18rem",
                        minWidth: "12rem", padding: "0.0rem",
                    }}>
                        {notifications === "" ? RenderNoNotifications() : RenderNotification(notifications[0])}


                        <Paper sx={{ marginBottom: "1.5rem" }} />
                        <a href="/karma/dashboard" onClick={(event) => {
                            var newUser = karmaContext.local.user;
                            newUser.seenLoginNotification = true;

                            karmaContext.setLocal(prevValue => {
                                return { ...prevValue, user: newUser };
                            });

                            event.preventDefault();
                            // window.location.reload();
                        }}>
                            <strong> continue </strong>
                        </a>
                    </Box>
                </Box>
            </Typography>
        </Box>
    );
}

function RenderNoNotifications() {
    return (
        <>

            <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                0 new notifications
            </Typography>
        </>
    );
}

function RenderNotification(notification) {
    return (
        <>

            <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                1 new notification
                <Box sx={{
                    borderRadius: "0.25rem",
                    borderColor: "rgba(221, 221, 221, 0.25)",
                    border: "1px solid rgba(221, 221, 221, 0.35)",
                    padding: "0.525rem", paddingTop: "0.525rem",
                    marginBottom: "0.5rem", marginTop: "1.125rem",
                    backgroundColor: "rgba(221, 221, 221, 0.05)",
                }}>
                    <Box sx={{ display: "flex", justifyContent: "center", marginBottom: "0.25rem", marginTop: "0.125rem", width: "100%", paddingTop: "0.175rem" }}>
                        <strong>{notification.body}</strong>
                    </Box>
                    <Box sx={{ marginTop: "0.75rem", marginBottom: "0.75rem" }}>
                        {notification.body2.includes("Remember") ? 
                        <>
                            Remember to use your 
                            <br />tokens 🫠
                        </>
                        : <>
                            Your tokens contributed {notification.body2}
                            <br />
                            to good causes 💕
                        </>}


                    </Box>
                </Box>
            </Typography>
        </>
    );
}

function RenderDashboardNotMember(props) {

    const karmaContext = useKarmaPoolContext();

    async function handleCheckout() {
        const stripe = await getStripe();
        const { error } = await stripe.redirectToCheckout({
            lineItems: [
                {
                    price: 'price_1NnkTa2MsJ2UXvaB9mb4qOL9',
                    quantity: 1,
                },
            ],
            mode: 'subscription',
            successUrl: `http://localhost:3000/success`,
            cancelUrl: `http://localhost:3000/cancel`,
            customerEmail: 'customer@email.com',
        });
        console.warn(error.message);
    }

    const [memberSlotsLeft, setMemberSlotsLeft] = useState(0);

    useEffect(() => {
        setMemberSlotsLeft(karmaContext.local.pool.memberSlots - karmaContext.local.pool.members);
    }, [karmaContext.local.pool]);

    return (
        <>
            <Box className={karmaStyles.homepageBox2}>
                <DashboardMenuHeaderComponent
                    homeEnabled={true}
                    nonMember={false} />
            </Box>

            <Box className={karmaStyles.homepageBox3}>
                <Box sx={{ paddingRight: "1.0rem", paddingLeft: "1.0rem", marginBottom: "0.25rem" }}>
                    <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <Paper sx={{ marginBottom: "0.5rem" }} />
                            <Box sx={{
                                width: "47.5%", maxWidth: "18rem",
                                minWidth: "13rem", padding: "0.0rem",
                            }}>
                                <Box sx={{ marginTop: "0.0rem" }}>
                                    <strong> Want to begin? </strong>
                                    <br /><br />
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="info"
                                        href='/karma/dashboard/membership'
                                        sx={{ backgroundColor: 'rgba(232, 232, 232, 0.5)', marginTop: "0.0rem", marginBottom: "0.0rem" }}>
                                        Join In
                                    </Button>
                                    <br />
                                </Box>
                            </Box>
                        </Box>
                        <Paper sx={{ marginBottom: "1.5rem" }} />
                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginBottom: "0.75rem" }}>
                            <Box sx={{
                                backgroundColor: "rgba(221, 221, 221, 0.05)",
                                borderRadius: "0.25rem",
                                borderColor: "rgba(221, 221, 221, 0.25)",
                                width: "47.5%", maxWidth: "18rem",
                                minWidth: "14rem", paddingTop: "1.0rem",
                                paddingBottom: "1.0rem",
                                border: "1px solid rgba(221, 221, 221, 0.35)",
                            }}>
                                TWITTER: {" "}
                                <Link href="https://twitter.com/karma_pool_" target="_blank" rel="noopener noreferrer">
                                    <strong>@karma_pool_</strong>
                                </Link>
                                <br />
                                INSTAGRAM: {" "}
                                <Link href="https://instagram.com/karma.pool" target="_blank" rel="noopener noreferrer">
                                    <strong>@karma.pool</strong>
                                </Link>
                            </Box>
                        </Box>
                    </Typography>
                </Box>
            </Box >


            <DashboardLogoutFooterComponent />
        </>
    );
}

function RenderDashboardPrimary() {
    return (
        <>
            <Box className={karmaStyles.homepageBox2}>
                <DashboardMenuHeaderComponent
                    homeEnabled={true} />
            </Box>

            <Box className={karmaStyles.homepageBox3}>
                <Box sx={{ paddingRight: "1.0rem", paddingLeft: "1.0rem", marginBottom: "0.5rem" }}>
                    <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <Paper sx={{ marginBottom: "0.5rem" }} />
                            <Box sx={{
                                width: "47.5%", maxWidth: "18rem",
                                minWidth: "12rem", padding: "0.0rem",
                            }}>
                                <Box sx={{ marginTop: "0.0rem" }}>
                                    <strong>Karma Pool Newsletter</strong>
                                    {/* on click, button should open /karma/dashboard/newsletter */}
                                    <Paper sx={{ marginBottom: "0.25rem" }} />
                                    <Button href="/karma/dashboard/newsletter" size="small" variant="contained"
                                        color="info" sx={{ marginTop: "0.5rem", backgroundColor: 'rgba(232, 232, 232, 0.5)' }}>
                                        Read
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                        <Paper sx={{ marginBottom: "1.5rem" }} />
                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginBottom: "0.75rem" }}>
                            <Box sx={{
                                backgroundColor: "rgba(221, 221, 221, 0.05)",
                                borderRadius: "0.25rem",
                                borderColor: "rgba(221, 221, 221, 0.25)",
                                width: "47.5%", maxWidth: "18rem",
                                minWidth: "14rem", paddingTop: "1.0rem",
                                paddingBottom: "1.0rem",
                                border: "1px solid rgba(221, 221, 221, 0.35)",
                            }}>
                                TWITTER: {" "}
                                <Link href="https://twitter.com/karma_pool_" target="_blank" rel="noopener noreferrer">
                                    <strong>@karma_pool_</strong>
                                </Link>
                                <br />
                                INSTAGRAM: {" "}
                                <Link href="https://instagram.com/karma.pool" target="_blank" rel="noopener noreferrer">
                                    <strong>@karma.pool</strong>
                                </Link>
                            </Box>
                        </Box>
                        <Paper sx={{ marginBottom: "1.5rem" }} />
                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <Paper sx={{ marginBottom: "0.5rem" }} />
                            <Box sx={{
                                width: "90.5%", maxWidth: "18rem",
                                minWidth: "12rem", padding: "0.0rem",
                            }}>
                                <Box sx={{ marginTop: "0.125rem" }}>
                                    <Typography variant="body2" sx={{ color: "whitesmoke", fontSize: "0.825rem" }}>
                                        Want to learn more? Read our {" "}
                                        <Link href="/karma/dashboard/faq" rel="noopener noreferrer">
                                            <strong>FAQ</strong>
                                        </Link>
                                        .
                                    </Typography>
                                    {/* on click, button should open /karma/dashboard/newsletter */}
                                    <Paper sx={{ marginBottom: "1.25rem" }} />

                                    <Typography variant="body2" sx={{ color: "whitesmoke", fontSize: "0.825rem" }}>

                                        <Link href="/karma/dashboard/membership" rel="noopener noreferrer">
                                            <strong>Manage Membership</strong>
                                        </Link>
                                    </Typography>
                                    <Paper sx={{ marginBottom: "0.625rem" }} />
                                    {/* underlined text */}

                                </Box>
                            </Box>
                        </Box>
                    </Typography>
                </Box>
            </Box>


            <DashboardLogoutFooterComponent />
        </>
    );
}

export default DashboardRoot;


